import React from "react";
import { PeekChip, PeekDivider, PeekStack } from "@piiqtechnologies/ui-components";
import { SearchInput } from "../search-input";
import { PageHeaderSelect, PageHeaderTitle, PageHeaderTopTitle } from ".";
export const PageHeader = ({ topTitle, reports, topRightContent, title, search, actions, initials, titleAdornment, }) => {
    return (React.createElement(PeekStack, { direction: "column", gap: 1 },
        React.createElement(PeekStack, { direction: "row", alignItems: "center", justifyContent: "space-between" },
            topTitle && React.createElement(PageHeaderTopTitle, { topTitle: topTitle }),
            !initials && (topRightContent !== null && topRightContent !== void 0 ? topRightContent : (reports && React.createElement(PageHeaderSelect, { reports: reports })))),
        React.createElement(PeekStack, { direction: "row", alignItems: "center", justifyContent: "space-between" },
            React.createElement(PeekStack, { direction: "row", gap: 2, alignItems: "center" },
                initials && (React.createElement(PeekChip, { size: "medium", variant: "filled", color: "primary", label: initials, sx: {
                        ".MuiChip-label": {
                            px: 0.75,
                            fontSize: "14px",
                            fontWeight: 600,
                        },
                        height: 36,
                        minWidth: 36,
                        borderRadius: 1,
                    } })),
                title && React.createElement(PageHeaderTitle, { title: title }),
                initials && reports && (React.createElement(React.Fragment, null,
                    React.createElement(PeekDivider, { light: true, orientation: "vertical", flexItem: true, sx: { mx: 0.5 } }),
                    React.createElement(PageHeaderSelect, { reports: reports }))),
                titleAdornment && (React.createElement(React.Fragment, null,
                    React.createElement(PeekDivider, { light: true, orientation: "vertical", flexItem: true, sx: { mx: 0.5 } }),
                    titleAdornment)),
                search && (React.createElement(SearchInput, { placeholder: search.placeholder, value: search.value, onChange: search.onChange, width: 320 }))),
            actions && (React.createElement(PeekStack, { direction: "row", alignItems: "center", gap: 2 }, actions)))));
};
export default PageHeader;
